import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  NotificationManager,
  NotificationContainer,
} from 'react-notifications';

import HotelLogo from '../components/common/HotelLogo';
import SectionHeader from '../components/common/SectionHeader';
import { getReservation, changeFolioAddress } from '../redux/reducer/actions';
import BillingAddressFormContainer from '../forms/billing-address-forms/BillingAddressFormContainer';

const BillingAddressPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { uniqueId, propertyId, selectedItemId } = useParams();
  const { tippingPageUrl } = useSelector((state) => state.app.urls);
  const reservationFolios = useSelector((state) => state.app.reservationFolios);
  const currentFolioIds = useSelector(
    (state) => state.app.currentFolioIds,
  ).data;
  const mainFolio = reservationFolios?.filter(
    (folio) => folio.isMainFolio === true,
  )[0];
  const initialValues = {
    title: mainFolio?.debitor?.title,
    firstName: mainFolio?.debitor?.firstName,
    lastName: mainFolio?.debitor?.name,
    email: mainFolio?.debitor?.email,
    addressLine1: mainFolio?.debitor?.address?.addressLine1,
    addressLine2: '',
    postalCode: mainFolio?.debitor?.address?.postalCode,
    city: mainFolio?.debitor?.address?.city,
    countryCode: mainFolio?.debitor?.address?.countryCode,
    additionalInformation: '',
  };

  useEffect(() => {
    dispatch(
      getReservation({ uniqueId, hotelId: propertyId, roomId: selectedItemId }),
    );
  }, [dispatch, propertyId, selectedItemId, uniqueId]);

  const onSubmit = async (values) => {
    let response;
    if (currentFolioIds && currentFolioIds.length === 1) {
      // For the newly created folio
      response = await dispatch(
        changeFolioAddress({
          hotelId: uniqueId,
          propertyId,
          folioId: currentFolioIds[0],
          values,
        }),
      );
    } else {
      // For paying all items or single folio
      response = await dispatch(
        changeFolioAddress({
          hotelId: uniqueId,
          propertyId,
          folioId: mainFolio.id,
          values,
        }),
      );
    }

    if (response.type.includes('rejected')) {
      NotificationManager.error(
        'Failed to update billing address',
        'Notification',
        3000,
      );
    } else {
      NotificationManager.success(
        'Success! Your billing address has been updated.',
        'Notification',
        3000,
      );
      navigate(tippingPageUrl);
    }
  };

  return (
    <main className="flex min-h-screen flex-col gap-16 py-16">
      <HotelLogo />
      <section id="billing-address" className="flex flex-col gap-6">
        <SectionHeader text="Your Billing Address" />
        <BillingAddressFormContainer
          initialValues={initialValues}
          cancelable={false}
          onSubmit={onSubmit}
        />

        <NotificationContainer />
      </section>
    </main>
  );
};

export default BillingAddressPage;
